import Home from '../pages/guest/Home';
import Vision from '../pages/guest/Vision';
import Guidlines from '../pages/guest/Guidlines';
import Terms from '../pages/guest/Terms';
import NoPage from '../pages/NoPage';
import { authRoutes } from './auth';
import { userRoutes } from './user';
import { lawyerRoutes } from './lawyer';
import { adminRoutes } from './admin';
import Overview from '../pages/guest/Overview';
import Policy from '../pages/guest/Policy';
import ComingSoon from '../pages/guest/ComingSoon';

const isLaunched = true;

// eslint-disable-next-line import/no-anonymous-default-export
export const routes = [{
        path: "/",
        element: isLaunched ? <Home /> : <ComingSoon /> ,
        errorElement: <NoPage />,
    }, {
        path: "/overview",
        element: <Overview />,
    }, {
        path: "/the-vision",
        element: <Vision />,
    }, {
        path: "/guidelines",
        element: <Guidlines />,
    }, {
        path: "/terms",
        element: <Terms />,
    },
    {
        path: "/policy",
        element: <Policy />,
    },
    ...authRoutes,
    userRoutes,
    ...lawyerRoutes,
    ...adminRoutes,

]